(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvTextAreaInputWithFieldSelector', drvTextAreaInputWithFieldSelector);

    drvTextAreaInputWithFieldSelector.$inject = [];
    TextAreaInputWithFieldSelectorCtrl.$inject = ['FieldSelectorService', 'DialogService'];
    
    /**
     * Text area field input which also includes the ability add merge fields using the field selector.
     *
     * # Scope Properties
     * {string} ngModel - The value which is to be bound to the text area input.
     * {object} entityTemplate - Entity template used to populate the field selector
     * {object} field - Field configuration object
     * @param {bool} includeOrganisation - Optional, default is false. True if fields for the 'Organisation'
     *   entity template are to be included in the Insert Field dialog.
     * @param {bool} includeCurrentUser - Optional, default is false. True if fields for the current user
     *   entity template are to be included in the Insert Field dialog.
     * @param {bool} includeDocumentTemplate - Optional, default is false. True if fields for the 'Document Template'
     * @param {bool} includeFileDetails - Optional, default is false. True if fields for the 'File'
     *   are to be included in the Insert Field dialog.
     * @param {bool} excludeFileDetailsName - Optional, default is false. True if 'Name' field for the 'File'
     *   is to be excluded in the Insert Field dialog.
     * @param {bool} includeEntitySystem - Optional, default is false. True if system fields for the entity
     *   are to be included in the Insert Field dialog.
     * @param {bool} includeEntitySystemForPreview - Optional, default is false. True if system fields for the entity preview
     *   are to be included in the Insert Field dialog.
     */
    function drvTextAreaInputWithFieldSelector() {
        var directive = {
            link: link,
            restrict: 'E',
            scope: {},
            controller: TextAreaInputWithFieldSelectorCtrl,
            controllerAs: 'vm',
            bindToController: {
                value: '=ngModel',
                entityTemplate: '=',
                field: '=',
                includeOrganisation: '<?',
                includeCurrentUser: '<?',
                includeDocumentTemplate: '<?',
                includeFileDetails: '<?',
                excludeFileDetailsName: '<?',
                includeEntitySystem: '<?',
                includeEntitySystemForPreview: '<?'
            },
            template:
                '<div ng-form="ta">' +
                '<md-input-container class="md-block">' +
                '<label>{{vm.field.Name}}</label>' +
                '<textarea name="{{vm.field.Name}}" rows="{{vm.field.Rows}}" ng-model="vm.value" ng-required="{{vm.field.Mandatory}}" ng-disabled="vm.field.Disabled"></textarea>' +
                '<div ng-messages="ta[vm.field.Name].$error"><div ng-message="required">{{vm.field.Name}} is required</div></div>' +
                '</md-input-container>' +
                '<a href="" ng-click="vm.clickAdd()" style="position:relative; bottom: 80px; right: 8px; float: right;">Insert Field(s)</a>' +
                '</div>'
        };
        return directive;

        function link(scope, element, attrs) {
            var inputElement = element[0].querySelector('textarea');
            if (inputElement === null) {
                throw 'Cannot link text field, no input element found in HTML template';
            }

            scope.vm.insertField = function (field) {
                var selectionStart;
                var selectionEnd;
                if (!_.isNil(inputElement.selectionStart) && !_.isNil(inputElement.selectionEnd)) {
                    selectionStart = inputElement.selectionStart;
                    selectionEnd = inputElement.selectionEnd;
                } else {
                    selectionStart = inputElement.value.length;
                    selectionEnd = inputElement.value.length;
                }

                var start = inputElement.value.substr(0, selectionStart);
                var end = inputElement.value.substr(selectionEnd);

                scope.vm.value = start + field + end;
            };
        }
    }

    function TextAreaInputWithFieldSelectorCtrl(FieldSelectorService, DialogService) {
        var vm = this;
        vm.clickAdd = clickAdd;

        function clickAdd() {
            FieldSelectorService.displayDialogForEntityTemplate(
                vm.entityTemplate, {
                    multiSelect: true,
                    fieldFormatter: FieldSelectorService.fieldFormatters.mergeFields,
                    includeOrganisation: vm.includeOrganisation,
                    includeCurrentUser: vm.includeCurrentUser,
                    includeDocumentTemplate: vm.includeDocumentTemplate,
                    includeFileDetails: vm.includeFileDetails,
                    excludeFileDetailsName: vm.excludeFileDetailsName,
                    includeEntitySystem: vm.includeEntitySystem,
                    includeEntitySystemForPreview: vm.includeEntitySystemForPreview
                }
            ).then(
                fieldSelectorOk,
                fieldSelectorError);

            function fieldSelectorOk(selectedFields) {
                var insertText = '';
                angular.forEach(selectedFields, function (selectedField) {
                    insertText += selectedField;
                });

                vm.insertField(insertText);
            }

            function fieldSelectorError(error) {
                if (!_.isNil(error)) {
                    DialogService.error(error);
                }
            }
        }
    }
})();